export default {
  timer: null,
  methods: {
    delay(cb) {
      return setTimeout(cb.bind(this), 200)
    }
  }
}
